module.exports = __webpack_public_path__ + "7259d70c3f10615bb64ab74e8febe9bc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-0.png
// module id = 2204
// module chunks = 0